/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Economics14Inputs */

const en__field_enum_study_economics14 = /** @type {(inputs: _Field_Enum_Study_Economics14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Economics`)
};

const de__field_enum_study_economics14 = /** @type {(inputs: _Field_Enum_Study_Economics14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirtschaftswissenschaften`)
};

/**
* | output |
* | --- |
* | "Economics" |
*
* @param {_Field_Enum_Study_Economics14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_economics14 = /** @type {((inputs?: _Field_Enum_Study_Economics14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Economics14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_economics14(inputs)
	return de__field_enum_study_economics14(inputs)
});
export { _field_enum_study_economics14 as "_field_enum_STUDY_ECONOMICS" }